import { Outlet } from "react-router-dom";

/**
 * Route guard — previously gated on onboarding completion.
 * Now a pass-through: onboarding is handled inline on the Home empty state.
 * Kept as a component to avoid unwrapping all route definitions.
 */
export const RequireActive = ({ children }: { children?: React.ReactNode } = {}) => {
  return children ? <>{children}</> : <Outlet />;
};
